import {combineReducers, createReducer} from '@reduxjs/toolkit';

import {
  hideModal,
  resize,
  setMode,
  setSaveErrors,
  showLeftDrawer,
  showModal,
  showRightDrawer,
} from '../actions/ui.js';
import {DRAWERS, UI_MODES} from '../constants/index.js';

export const size = createReducer({width: NaN, height: NaN}, builder => {
  builder.addCase(resize, (state, {payload: {width, height}}) => {
    state.width = width;
    state.height = height;
  });
});

const initialDrawerState = {
  left: DRAWERS.COLLECTIONS,
  right: '',
};

export const drawers = createReducer(initialDrawerState, builder => {
  builder.addCase(showLeftDrawer, (state, {payload}) => {
    state.left = payload;
  });

  builder.addCase(showRightDrawer, (state, {payload}) => {
    state.right = payload;
  });
});

export const modal = createReducer(null, builder => {
  builder.addCase(showModal, (state, {payload}) => payload);
  builder.addCase(hideModal, () => null);
});

const initialMode = UI_MODES.BROWSE;

const mode = createReducer(initialMode, builder => {
  builder.addCase(setMode, (state, {payload}) => payload);

  builder.addCase(showLeftDrawer, state => {
    return state;
  });
});

const saveState = createReducer(
  {
    errors: [],
  },
  builder => {
    builder.addCase(setSaveErrors, (state, {payload}) => {
      state.errors = payload;
    });
  }
);

export default combineReducers({
  size,
  mode,
  modal,
  drawers,
  saveState,
});
